import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';


@Injectable()
export class GoogleMapsConfig {
  apiKey: string;
  libraries: string[];

  constructor() {
    this.apiKey = environment.googleApiKey;
    this.libraries = ['places'];
  }
}
